import { z } from 'zod';

import {
  ConditionSchema,
  ConditionMatchType,
  FieldType,
  OptionSchema,
  CustomQuestionScope,
} from '../experience/custom-questions';

export const AnswerSchema = z.object({
  value: z.union([z.string(), z.array(z.string()), z.boolean()]).nullable(),
  key: z.string().nullable().optional(),
});
export type Answer = z.infer<typeof AnswerSchema>;

export const AggregateQuestionSchema = z.object({
  customQuestionId: z.string(),
  prompt: z.string(),
  fieldType: z.nativeEnum(FieldType),
  options: z.array(OptionSchema).nullable(),
  termsAndConditions: z
    .object({
      label: z.string(),
      mediaId: z.string(),
      isOverrided: z.boolean(),
      mediaUrl: z.string().optional(),
    })
    .nullable(),
  config: z.object({
    experienceId: z.string(),
    experienceQuestionId: z.string(),
    isRequired: z.boolean(),
    isActive: z.boolean(),
    order: z.number(),
    scope: z.nativeEnum(CustomQuestionScope),
    conditions: z.array(ConditionSchema).nullable(),
    conditionsMatchType: z.nativeEnum(ConditionMatchType).nullable(),
  }),
});

export const CustomQuestionAnswerBookingResponseSchema = z.object({
  id: z.string(),
  answer: z.array(AnswerSchema),
  question: AggregateQuestionSchema,
});
